import {
    AuthPage,
} from "@refinedev/mui";
import { ThemedTitle }from "../../components/themedTitle/index";

export const Login = () => {

    return (
        <AuthPage
            title={
                <ThemedTitle/>
            }
            forgotPasswordLink={false}
            registerLink={false}
            type="login"
            formProps={{ defaultValues:{ name: "", password: "" } }}
        />
    );
};
